import { render, staticRenderFns } from "./LetterBox.vue?vue&type=template&id=416d39dc&"
import script from "./LetterBox.vue?vue&type=script&lang=js&"
export * from "./LetterBox.vue?vue&type=script&lang=js&"
import style0 from "./LetterBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports